import { Service } from './http-service';
import type {
  CreateRotationMediaDto,
  RotationMediaPoolItemDto,
  RotationMediaResponseDto,
  UpdateRotationMediaDto,
} from '@carvia/ros-client-types';

class MediaRotationService extends Service<
  RotationMediaResponseDto,
  CreateRotationMediaDto,
  UpdateRotationMediaDto
> {
  constructor() {
    super('/media-rotation');
  }

  async getCurrent(): Promise<RotationMediaPoolItemDto[]> {
    const res = await this.httpClient.get<RotationMediaPoolItemDto[]>(`${this.endpoint}/current`);
    return res.data;
  }

  async getVideoWallCurrent(
    stationSlug: string,
    authCode?: string,
  ): Promise<RotationMediaPoolItemDto[]> {
    const res = await this.httpClient.get<RotationMediaPoolItemDto[]>(
      `${this.endpoint}/video-wall/${encodeURIComponent(stationSlug)}/current`,
      { params: authCode ? { code: authCode } : undefined },
    );
    return res.data;
  }
}

export const mediaRotationService = new MediaRotationService();
